import React, { useState, useEffect } from "react";
import MainHeader from "./components/mainNavbar";
import MainFooter from "./components/mainFooter";

function App() {
  const [newsboxes, setNewsboxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("http://134.209.177.28:8080/newsboxes", {});
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await res.json();
        setNewsboxes(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error)
    return (
      <div>
        Error: {error.message}
      </div>
    );
  return (
    <>
    <MainHeader/>
    <div className="min-h-screen flex row justify-center sm:mx-28">

      <div className="mb-4">
        <div className="mb-2">
          <img
            src="/images/Kenyans-Link-In-Bio-Cover-Photo-01-1536x569.jpg.jpeg"
            height={100}
            width={1000}
            alt="Link in bio Banner"
            quality={100}
            className="w-full h-auto"
          />
          <h1 className="text-sm font-semibold text-center my-5 ml-1 sm:text-lg">
            Tap on an image to learn more
          </h1>
        </div>

        <div className="grid grid-cols-3 gap-1">
          {newsboxes.map((newsbox, index) =>
            <a
              key={index}
              href={newsbox.field_article_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={newsbox.field_news_box_image}
                alt="News Poster"
                className="aspect-square object-cover"
                width={360}
                height={360}
                quality={100}
              />
            </a>
          )}
        </div>
      </div>
     
    </div>
    <MainFooter/>
    </>
  );
}

export default App;

